export default {
  async asyncData({ store, params, $services }) {
    try {
      const product = await store.dispatch('rph-products/getProductBySlug', {
        slug: params.product ? params.product : params.slug,
        category: params.category ? params.category : 'product',
        params: {
          params: {
            expand:
              'default_state,images,specification,producers,seo,category,trade_name,have_analogs,annotation',
          },
        },
      })
      const annotations = $services.product.mapDropDownSpecs(product.annotation)
      store.commit('rph-products/setAnnotations', annotations)
    } catch (error) {
      console.log(error)
    }
    await store.dispatch('rph-categories/getCategoryBySlug', {
      slug: params?.category
        ? params?.category
        : store.getters['rph-products/product'].category?.slug,
      params: {
        params: { expand: 'parents' },
      },
    })
  },
  fetchOnServer: false,
  async fetch() {
    const product = this.$store.getters['rph-products/product']

    if (product?.trade_name?.slug && product?.have_analogs) {
      try {
        await this.$store.dispatch('rph-products/getProductAnalogs', {
          slug: product.trade_name.slug,
          params: {
            params: {
              expand: 'products,inns',
              'per-page': 5,
            },
          },
        })
      } catch (error) {
        console.warn('Ошибка при получении аналогов', error)
      }
    }
  },
  head() {
    const scripts = [
      {
        hid: 'structured-data-product',
        innerHTML: JSON.stringify(this.structuredData),
        type: 'application/ld+json',
      },
      {
        hid: 'structured-data-image',
        innerHTML: JSON.stringify(this.structuredImage),
        type: 'application/ld+json',
      },
    ]

    // if (this.reviews.length) {
    //   scripts.push({
    //     hid: 'structured-data-reviews',
    //     innerHTML: JSON.stringify(this.structuredReviews),
    //     type: 'application/ld+json',
    //   })
    // }
    // if (this.shouldIncludeGTM) {
    //   scripts.push({
    //     hid: 'gtm-script',
    //     innerHTML: `
    //     (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    //     })(window,document,'script','dataLayer','GTM-NPGJJ68P');
    //   `,
    //     type: 'text/javascript',
    //     charset: 'utf-8',
    //   })
    // }

    return {
      title: this.seo?.title,
      meta: this.$services.head.createMeta({
        title: this.seo?.title,
        description: this.seo?.description,
        keywords: this.seo?.keywords,
        ogImage: this.seo?.og_image,
      }),
      link: [this.$services.head.createCanonicalLink(this.$route.path)],
      script: scripts,
      __dangerouslyDisableSanitizers: ['script'],
      __dangerouslyDisableSanitizersByTagID: {
        'gtm-script': ['innerHTML'],
      },
    }
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('rph-products/getRecommendedProducts', {
        params: {
          product_id: this.$store.getters['rph-products/product'].id,
          limit: 5,
          expand: 'default_state,images,category,producers,specification',
        },
      }),
      this.$store.dispatch('rph-reviews/getReviews', {
        params: {
          params: {
            'filter[object]': 'product',
            'filter[object_id]': this.$store.getters['rph-products/product'].id,
          },
        },
      }),
    ])
    if (this.shouldIncludeGTM && !document.getElementById('gtm-script-dynamic')) {
      const script = document.createElement('script')
      script.id = 'gtm-script-dynamic'
      script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NPGJJ68P');
    `
      document.head.appendChild(script)
    }
  },
  computed: {
    seo() {
      return this.product.seo
    },
    product() {
      return this.$store.getters['rph-products/product']
    },
    openAdultModal() {
      return this.$store.getters['rph-modals/adultConfirmModal']
    },
    categoryBySlug() {
      return this.$store.getters['rph-categories/categoryBySlug']
    },
    availablePrice() {
      return this.product ? this.$services.price.getDefaultPrice(this.product.default_state) : ''
    },
    reviews() {
      return this.$store.getters['rph-reviews/reviews']
    },
    structuredData() {
      const product = this.product

      const data = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product?.title || '',
        description: Object.values(product.annotation || {})
          .filter((v) => v)
          .join(' ')
          .replace(/<\/?[^>]+(>|$)/g, '')
          .trim(),
        brand: product?.short_title || '',
        url: this.$route.path,
        image: product?.images?.[0]?.links?.medium || '',
        category: product?.category?.title,
        manufacturer: {
          '@type': 'Organization',
          name: product?.producers?.title || '',
        },
        countryOfOrigin: {
          '@type': 'Country',
          name: product?.specification?.country || '',
        },
        gtin: product?.specification?.barcode || '',
      }

      if (product?.default_state.max_count > 0) {
        data.offers = {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: product?.default_state?.price || '',
          priceCurrency: 'KZT',
          seller: {
            '@type': 'Organization',
            '@id': 'https://aurma.kz/seller',
            name: 'Aurma.kz',
            url: 'https://aurma.kz/',
          },
        }
      }

      return data
    },
    structuredImage() {
      return {
        '@context': 'https://schema.org',
        '@type': 'ImageObject',
        contentUrl:
          this.product && this.product.images.length ? this.product.images[0].links.medium : '',
        name: this.product ? this.product.title : '',
      }
    },

    // structuredReviews() {
    //   return this.reviews.map((review) => {
    //     return {
    //       '@context': 'https://schema.org',
    //       '@type': 'Review',
    //       reviewBody: review.content,
    //       reviewRating: {
    //         '@type': 'Rating',
    //         worstRating: '1',
    //         bestRating: '5',
    //         ratingValue: review.rate,
    //       },
    //       author: {
    //         '@type': 'Person',
    //         name: review?.user?.name ?? '',
    //       },
    //       itemReviewed: {
    //         '@type': 'Product',
    //         name: this.product.title,
    //       },
    //     }
    //   })
    // },
    shouldIncludeGTM() {
      const allowedSlugs = [
        '4464-lineks-forte',
        '7062-lineks-forte',
        '4259-lineks',
        '28845-lineks-forte',
        '3487-lineks',
        '9529-ekzoderil',
        '8700-ekzoderil',
        '10216-ekzoderil',
        '3502-ekzoderil',
      ]
      return allowedSlugs.includes(this.$route.params.slug)
    },
  },
}
